<template>
  <div class="container">
    <slot name="title"></slot>
    <div class="row">
      <div class="col-12 col-lg-6">
        <slot name="left-column"></slot>
      </div>
      <div class="col-12 col-lg-6">
        <slot name="right-column"></slot>
        <ReceiptEmailer></ReceiptEmailer>
      </div>
    </div>
    <div>
      <hr />
      <BaseText class="mb-0" text="InstantApprovalPage.ResultScreen.close.page"></BaseText>
    </div>
  </div>
</template>

<script setup lang="ts">
import ReceiptEmailer from '@/components/instantApproval/result/ReceiptEmailer.vue';
</script>
